/*
 * @Author: huangl
 * @Date: 2020-08-18 13:38:00
 * @LastEditors: huangl
 * @LastEditTime: 2020-08-26 09:26:13
 * @Description: file content
 * @FilePath: \officesystem\src\api\notice.js
 */

import Vue from 'vue'
import { Message, Modal, Notice } from 'view-design';
import loading from '@/components/commons/loading'
import ViewUI from 'view-design';
let notice = {
  success: function (text) {
    //中间轻提示框
    Message.success({
      background: true,
      content: text,
      duration: 3
    });
  },
  msg: function (text) {
    //中间轻提示框
    Message.info({
      background: true,
      content: text,
      duration: 3
    });
  },
  error: function (text) {
    //中间轻提示框
    Message.error({
      background: true,
      content: text,
      duration: 5
    });
  },
  alert: function (text, btn, yes) {
    Modal.success({
      title: '信息',
      content: text,
    });
  },
  footer: function (text, type) {
    //侧边提示框
    Notice.open({
      title: '提示',
      desc: text
    });
  },
  loading: function (text) {
    //加载中
    var loading = Message.loading({
      content: text,
      duration: 0
    })
    return loading
  },
  showLoading: () => {
    ViewUI.Spin.show();
  },
  hideLoading: () => {
    ViewUI.Spin.hide();
  },
  /**
   * 询问框弹窗
   * text-文字
   * btns-按钮文本
   * yes-成功回调
   * no-失败回调
   */
  inquiry: function (text, btns = ['确认', '取消']) {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        title: '信息',
        content: text,
        okText: btns[0],
        cancelText: btns[1],
        onOk() {
          resolve()
        },
        onCancel() {
          reject()
        }
      })
    })

  },
  close(index) {

  },
  closeAll() {

  }
}


export default notice
